import { render, staticRenderFns } from "./YA_HomePricing.vue?vue&type=template&id=1fb5fc1b&scoped=true"
import script from "./YA_HomePricing.vue?vue&type=script&lang=js"
export * from "./YA_HomePricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb5fc1b",
  null
  
)

export default component.exports